import { PageApi } from 'api/PageApi';
import { mapPageDtoListToModel, mapPageModelToDto, PageModel } from 'api/dto/Page.dto';

export class PageRepository {
  constructor(private pageApi: PageApi) {}

  list(projectId: number): Promise<PageModel[]> {
    return this.pageApi.list(projectId).then((entries = []) => mapPageDtoListToModel(entries));
  }

  create(projectId: number, page: PageModel): Promise<PageModel[]> {
    return this.pageApi.create(projectId, mapPageModelToDto(page)).then(() => this.list(projectId));
  }

  update(projectId: number, page: PageModel): Promise<PageModel[]> {
    return this.pageApi.update(mapPageModelToDto(page)).then(() => this.list(projectId));
  }

  delete(pageId: number): Promise<void> {
    return this.pageApi.delete(pageId);
  }

  moveUp(projectId: number, page: PageModel): Promise<PageModel[]> {
    return this.pageApi
      .update(mapPageModelToDto(PageModel.moveUp(page)))
      .then(() => this.list(projectId));
  }

  moveDown(projectId: number, page: PageModel): Promise<PageModel[]> {
    return this.pageApi
      .update(mapPageModelToDto(PageModel.moveDown(page)))
      .then(() => this.list(projectId));
  }
}
